<template>
  <div class="message-attachment"
       :title="datetime">
    <a class="message-attachment__file"
       target="_blank"
       v-if="!isImage"
       :href="attachment.url">
      <i :class="fileIcon"></i>
      <p>You sent a file</p>
    </a>
    <a class="message-attachment__image"
       target="_blank"
       v-if="isImage"
       :href="attachment.url"
       :style="{backgroundImage: image}">
      <div v-if="loading" class="loading-spinner">
        <smd-loading-spinner/>
      </div>
      <!--      <img v-if="attachment.url"-->
      <!--           :src="attachment.url"-->
      <!--           @load="imageLoaded">-->
      <p v-if="error" class="error">Preview not found.</p>
      <p class="time">{{ time }}</p>
    </a>
  </div>
</template>

<script>
  import moment from 'moment';
  import {MessageService} from '@/services/messages';

  export default {
    name: 'MessageAttachment',
    props: {
      message: {type: Object, required: true},
      token: {type: String, required: true},
    },
    data() {
      return {
        error: false,
        loading: false,
        attachment: {},
      };
    },
    computed: {
      datetime() {
        return moment(this.message.datecreated).format('MMMM D, YYYY hh:mm a');
      },
      time() {
        return moment(this.message.datecreated).format('hh:mm a');
      },
      fileExtension() {
        const fileExtension = this.message.uploadid.split('.');
        return fileExtension.pop();
      },
      image() {
        return `url(${this.attachment.url})`;
      },
      isImage() {
        const imageExtensions = ['jpeg', 'jpg', 'png', 'gif'];
        return imageExtensions.includes(this.fileExtension);
      },
      fileIcon() {
        return this.fileExtension === 'pdf' ? 'ns-icon-pdf-file' : 'ns-icon-text-file';
      },
    },
    mounted() {
      this.fetchPreview();
    },
    methods: {
      async fetchPreview() {
        this.loading = true;

        try {
          const {data} = await MessageService.getAttachment(this.message.uploadid, this.token);
          this.attachment = data;
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.error = true;
        }
      },
      imageLoaded() {
        this.$emit('loaded');
      },
    },
  }
</script>

<style lang="scss">
  .message-attachment__file {
    @include box-shadow($shadow);
    display: flex;
    align-items: center;
    padding: space(s) space(m);
    border-radius: radius(medium);
    color: inherit;

    i {
      font-size: font(xxl);
      margin-right: space(s);
      color: color(gray, text);
    }
  }

  .message-attachment__image {
    background-size: 90%;
    background-position: 49% 67%;
    background-repeat: no-repeat;
    display: block;
    overflow: hidden;
    border-radius: radius(medium);
    height: 250px;
    width: 150px;
    position: relative;

    img {
      display: block;
      width: 100%;
    }

    .loading-spinner {
      padding: space(s);
    }

    .error {
      text-align: center;
      padding: space(s);
      color: color(red, brand);
    }

    .time {
      font-size: font(s);
      text-align: right;
      padding: space(xs) space(m);
      color: color(white, text);
      background-color: color(blue, brand);
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
</style>
